import { Button, Callout } from '@opengoal/ui';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '../hooks/useCurrentUser';
import { useSignOut } from '../hooks/useSignOut';

/**
 * Shown on the emailed-link pages when someone is already signed in.
 *
 * These pages are deliberately reachable while authenticated — an invitation
 * often arrives on a machine where a colleague never signed out, and silently
 * redirecting to the dashboard makes a perfectly valid link look broken. So
 * instead: say who is signed in, and let them choose.
 *
 * Renders nothing when signed out, so the pages can include it unconditionally.
 */
export function SignedInBanner() {
  const { t } = useTranslation();
  const user = useCurrentUser();
  const signOut = useSignOut();

  if (!user) return null;

  return (
    <Callout
      variant="info"
      title={t('auth.signedInAs', { email: user.email })}
      description={
        <div className="grid justify-items-start gap-3">
          {t('auth.signedInAsHint')}
          <Button size="sm" variant="outline" onClick={() => void signOut()}>
            {t('auth.signOut')}
          </Button>
        </div>
      }
    />
  );
}
